import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type * as models from '../../models'
import * as fragments from '../fragments'

import { transformUserInfo } from './transform-user-info'

const DOC = gql`
  ${fragments.siblingUser.DOC}
  query MeUsersInZone($tenantId: ID!, $zoneId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        users {
          items {
            info {
              ...FragmentMeSiblingUser
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.MeUsersInZoneQuery,
    readonly models.User[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'users',
        graphql.transformers.OUT.select(
          'items',
          graphql.transformers.OUT.default(
            graphql.transformers.OUT.list(
              graphql.transformers.OUT.custom(user =>
                transformUserInfo(user?.info),
              ),
              { onNullish: 'remove' },
            ),
            [],
          ),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.MeUsersInZoneQuery,
  readonly models.User[],
  graphql.schema.MeUsersInZoneQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
